import { useCallback } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { usePayment } from '../context';
import { collectRiskSignals } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/hooks/use-risk-signals';
import { completePayment } from '../services/payment-api';
import type { AssertionResponse } from '../services/webauthn';

export function usePaymentAuthentication(): (
  assertionData: AssertionResponse
) => Promise<void> {
  const tenant = useTenant();
  const { data, dispatch } = usePayment();

  return useCallback(async (assertionData: AssertionResponse) => {
    dispatch({ type: 'START_SUBMITTING_AUTH' });

    try {
      const riskSignals = collectRiskSignals();
      const response = await completePayment(
        data.paymentHash,
        assertionData,
        riskSignals,
        tenant.code,
      );

      if (response.status === 'SUCCESS') {
        dispatch({ type: 'AUTH_SUBMITTED' });
      } else {
        dispatch({
          type: 'SET_ERROR',
          errorMessage: response.status_message || 'Falha na autenticação do pagamento.',
        });
      }
    } catch (err: unknown) {
      dispatch({
        type: 'SET_ERROR',
        errorMessage: (err as Error).message || 'Falha na autenticação do pagamento.',
      });
    }
  }, [data.paymentHash, tenant.code, dispatch]);
}
